import dayjs from 'dayjs'
import config from '../config.json'
import $t from '../i18n'
import { ACTIVITY_CATEGORIES, routes } from '../consts'

export const getActivityListByMember = (list, selectedMember) =>
  selectedMember?.id
    ? list?.filter(
        notification =>
          notification?.patientId.toString() === selectedMember?.id.toString()
      )
    : list

export const getEnrollmentPaymentNotification = (
  isEnrollmentPaymentAvailable,
  effectiveDate
) => ({
  category: ACTIVITY_CATEGORIES.PAYMENTS_AND_FUNDS,
  navigation: { type: 'link', sow_screen_name: routes.MENU_ROUTE.PAYMENTS },
  details: $t(
    `homeScreen.myActivity.enrollmentPayment.${
      isEnrollmentPaymentAvailable ? 'post' : 'pre'
    }.subtitle`,
    {
      effective_date: dayjs(effectiveDate || null).format(
        config.genericDateFormat
      ),
    }
  ),
  id: 'enrollment_payment',
  isRead: false,
  isPinned: true,
  title: $t(
    `homeScreen.myActivity.enrollmentPayment.${
      isEnrollmentPaymentAvailable ? 'post' : 'pre'
    }.title`
  ),
})

// Shown between the member paying and Cognizant confirming that payment, in place
// of the request-for-payment card above.
export const getPaymentReceivedNotification = () => ({
  category: ACTIVITY_CATEGORIES.PAYMENTS_AND_FUNDS,
  navigation: { type: 'link', sow_screen_name: routes.MENU_ROUTE.PAYMENTS },
  details: $t('homeScreen.myActivity.paymentReceived.subtitle'),
  id: 'payment_received',
  isRead: false,
  isPinned: true,
  title: $t('homeScreen.myActivity.paymentReceived.title')
})
